import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useEffect, useRef } from "react";
import { Box, Flex } from "sprout-ui-primitives";
import { themeGet, media } from "sprout-ui-theme";
import scrollIntoView from "scroll-into-view-if-needed";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { Form } from "sprout-ui-dom/dist/Form";
import OutsideClickListener from "sprout-ui-dom/dist/internal/OutsideClickListener";
import TopicPageEditorDividerColorPicker from "./TopicPageEditorDividerColorPicker";
const Input = styled("input")`
  appearance: none;
  border: 0;
  outline: 0;
  background: transparent;
  width: 100%;

  /* Try to mimic TopicPageEditor as much as possible */
  font-size: 20px;
  line-height: 26px;
  padding: 16px 0;

  &::placeholder {
    color: ${themeGet("colors.black.60")};
  }
`;
const ButtonsWrapper = styled(Flex)`
  width: 100%;
  margin-bottom: 16px;

  ${media.up("small")} {
    width: auto;
    margin-top: 16px;
    margin-left: 8px;
    margin-right: -8px;
  }

  ${media.down("339px")} {
    button {
      padding: 0 8px;
    }
  }

  button + button {
    margin-left: 4px;
  }
`;
const TopicPageEditorDividerDesktop = (props)=>{
    const { title , closeEditor , color: colorProp , onCreate  } = props;
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    useEffect(()=>{
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
        if (containerRef.current) scrollIntoView(containerRef.current, {
            block: "center"
        });
    }, []);
    const [inputValue, setInputValue] = useState(title || "");
    const inputValueRef = useRef(inputValue);
    const handleValueChange = useCallback((event)=>{
        const { value  } = event.target;
        setInputValue(value);
        inputValueRef.current = value;
    }, []);
    //
    const [color, setColor] = useState(colorProp || "black");
    const colorRef = useRef(color);
    const handleColorChange = useCallback((nextColor)=>{
        setColor(nextColor);
        colorRef.current = nextColor;
    }, []);
    //
    const handleSubmit = useCallback(()=>{
        onCreate({
            title: inputValueRef.current,
            color: colorRef.current
        });
    }, [
        onCreate
    ]);
    //
    const handleKeyDown = useCallback((event)=>{
        const { value  } = event.target;
        if (event.key === "Escape") closeEditor();
        if (value.length === 0) return;
        if (event.key === "Enter") handleSubmit();
    }, [
        handleSubmit,
        closeEditor
    ]);
    return /*#__PURE__*/ _jsx(OutsideClickListener, {
        onOutsideClick: closeEditor,
        children: /*#__PURE__*/ _jsxs(Flex, {
            as: Form,
            alignItems: "center",
            flexWrap: "wrap",
            borderRadius: "8px",
            px: 3,
            my: 1,
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "grey.300",
            onSubmit: handleSubmit,
            ref: containerRef,
            children: [
                /*#__PURE__*/ _jsxs(Box, {
                    flex: "1",
                    children: [
                        /*#__PURE__*/ _jsx(Input, {
                            ref: inputRef,
                            value: inputValue,
                            onChange: handleValueChange,
                            onKeyDown: handleKeyDown,
                            maxLength: 160,
                            placeholder: "Add a leaf divider"
                        }),
                        /*#__PURE__*/ _jsx(TopicPageEditorDividerColorPicker, {
                            value: color,
                            onChange: handleColorChange
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(ButtonsWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "submit",
                            variant: "bright-blue",
                            size: "sm",
                            children: title ? "Save changes" : "Add leaf divider"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "outline",
                            size: "sm",
                            onClick: closeEditor,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
};
export default TopicPageEditorDividerDesktop;
